export default "__VITE_ASSET__BXZtrhWE__"